import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {User} from "./components/User";
import {Dictionary} from "./components/Dictionary";
import {XHR} from "./components/XHR";
import {Router} from "./Router";
import {PublicRouter} from "./PublicRouter";
// import {io, Socket} from "socket.io-client";

class Index {
    private readonly user: User = new User();
    private readonly request: XHR = new XHR();
    private readonly dictionary: Dictionary = new Dictionary();

    public setUp(): void {
        this.request.base = process.env.REACT_APP_API_URL || '';
        this.user.init();

        if (this.dictionary.valid()) {
            this.createRoot();
            return;
        }

        this.request.fetchDictionary().then(() => {
            this.createRoot();
        });
    };

    private createRoot() {
        // this.user.valid() && this.connectIo();
        ReactDOM.createRoot(
            document.getElementById('root') as HTMLElement
        ).render(this.getReactChildren());
    };

    private getReactChildren(): React.ReactNode {
        // if (process.env.REACT_APP_STRICT) {
        //     return this.user.valid() ?
        //         <React.StrictMode><Router/></React.StrictMode> :
        //         <React.StrictMode><LoginPage/></React.StrictMode>;
        // }
        return this.user.valid() ? <Router/> : <PublicRouter/>;
    };

    // private connectIo() {
    //     const socket: Socket = io((process.env.REACT_APP_SIO_URL as string), {
    //         withCredentials: true, extraHeaders: {authorization: `bearer ${this.user.getToken()}`}
    //     });
    //
    //     socket.on('dictionary-update', (version) => {
    //         this.request.fetchDictionary().then(r => {
    //             console.log('dictionary-update ready, version: ' + version);
    //         });
    //     });
    //
    //     // console.log('user-update-' + this.user.version);
    //
    //     socket.on('user-update-' + this.user.version, (version) => {
    //         console.log('user-update TODO, version: ' + version);
    //     });
    //
    //     socket.emit('check-dictionary', this.dictionary.dictionaryVersion);
    //     socket.emit('check-user', this.user.version);
    //     return true;
    // };
}

(new Index()).setUp();

// import reportWebVitals from './reportWebVitals';
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
